import { useTranslation } from "lib/i18n/translation"
import { useCountry } from "lib/country"
import { useProductsFilters, BOTTOM_FILTER } from "lib/products"
import { MOVEMENT, TYPE, ACCESSIBILITY, GENRE } from "lib/tools/categories-list"

import { checkFilterDisplay } from "./navigation"

const getFiltersColumns = filters => {
	const filtersOrder = [TYPE, ACCESSIBILITY, GENRE, MOVEMENT]
	const columns = [{
		title: "",
		sticky: false,
		filters: []
	}]

	filtersOrder.forEach(filter => {
		const currentFilter = filters.find(f => f.title === filter)

		if (filter === TYPE || filter === ACCESSIBILITY) {
			columns[0].title = columns[0].title === ""
				? currentFilter.title
				: columns[0].title
			columns[0].sticky = columns[0].sticky === true
				? columns[0].sticky
				: currentFilter.sticky
			columns[0].filters.push(currentFilter)
		} else {
			columns.push({
				title: currentFilter.title,
				sticky: currentFilter.sticky,
				filters: [currentFilter]
			})
		}
	})

	return columns
}

export default ({}) => {
	const {
		filters,
		updateFilters,
		availableFilters
	} = useProductsFilters()
	const { country } = useCountry()
	const { c } = useTranslation("common")

	const addBottomFilter = (e, filter) => {
		e.preventDefault();
		updateFilters(BOTTOM_FILTER, filters.bottom.concat([filter]))
	}
	const removeBottomFilter = (e, filter) => {
		e.preventDefault();
		updateFilters(BOTTOM_FILTER, filters[BOTTOM_FILTER].filter(f => f.id !== filter.id))
	}

	const columns = getFiltersColumns(availableFilters.bottom)

	return (
		<>
			<nav className="filters-tags current only-mobile">
				<span data-filters-current="" className="filters-tags-current">{c("your-filters")} : {filters[BOTTOM_FILTER].length == 0 ? c("none") : ""}</span>
				{ filters[BOTTOM_FILTER].map(filter => (
						<a href="#" rel="nofollow noopener" className="active" onClick={e => { e.preventDefault(); removeBottomFilter(e, filter) }} title={filter.name}>{filter.name}</a>
				))}
			</nav>
			<h2 className="overlay-title icon-filters">{c("all-filters")}</h2>
			<ul className="columns">
				{columns.map(column => (
					<li
						key={column.title}
						className={column.sticky ? "has-sticky-infos" : ""}
					>
						{column.filters.map(filter => checkFilterDisplay(filter, country.default_language) && (
							<>
								<h3 className="title">{c(`filter-type-${filter.title}`)}</h3>
								<nav className="filters-tags list">
									{filter.values.map(fValue => {
										const active = filters[BOTTOM_FILTER].map(f => f.id).includes(fValue.id)

										return (
											<a
												href="#"
												onClick={e => { e.preventDefault(); active ? removeBottomFilter(e, fValue) : addBottomFilter(e, fValue) }}
												rel="nofollow noopener"
												className={active ? "active" : ""}
												data-filter="fiction"
												title={c("fiction")}
												data-sticky={`#${fValue.linkRewrite}`}
											>
												{fValue.name}
												{filter.sticky && (
													<div id={fValue.linkRewrite} className="is-sticky-infos">
														<h3>{fValue.name}</h3>
														<p className="excerpt">{fValue.descriptionShort}</p>
														<div className="description" dangerouslySetInnerHTML={{ __html: fValue.description }} />
													</div>
												)}
											</a>
										)
									})}
								</nav>
							</>
						))}
					</li>
				))}
			</ul>
		</>
	)
}
